import { Controller } from "@hotwired/stimulus";

// Gestiona la seleccion dinamica de plans (experiencias) en el tab avanzado.
// Permite agregar/quitar plans sin recargar la pagina.
// Integrado con Tom Select para busqueda remota de plans.
//
// Uso:
//   <div data-controller="manage--advanced-plans">
//     <div data-manage--advanced-plans-target="list">...</div>
//     <div data-manage--advanced-plans-target="empty">...</div>
//     <span data-manage--advanced-plans-target="count">0</span>
//     <select data-manage--advanced-plans-target="select" data-controller="manage--tom-select">...</select>
//     <div data-manage--advanced-plans-target="addWrap">...</div>
//   </div>

export default class extends Controller {
  static targets = ["list", "select", "empty", "count", "addWrap"];

  connect() {
    this.updateState();
  }

  add() {
    const select = this.selectTarget;
    const ts = select.tomselect;

    if (ts) {
      const id = ts.getValue();
      if (!id) return;

      const item = ts.options[id];
      if (!item) return;

      const name = item.name || item.text || "";
      this.listTarget.insertAdjacentHTML("beforeend", this.buildPlanItem(id, name));
      ts.removeOption(id);
      ts.clear(true);
    } else {
      const option = select.options[select.selectedIndex];
      if (!option || !option.value) return;

      const id = option.value;
      const name = option.dataset.name || option.textContent.trim();
      this.listTarget.insertAdjacentHTML("beforeend", this.buildPlanItem(id, name));
      option.remove();
      select.value = "";
    }

    this.updateState();
    this.toggleAddMode(false);
  }

  remove(event) {
    const item = event.currentTarget.closest("[data-plan-id]");
    item.remove();
    this.updateState();
  }

  showAdd() {
    this.toggleAddMode(true);

    // Focus Tom Select después de mostrar
    const ts = this.selectTarget.tomselect;
    if (ts) {
      requestAnimationFrame(() => ts.focus());
    }
  }

  hideAdd(event) {
    if (!this.addWrapTarget.contains(event.target)) {
      this.toggleAddMode(false);
    }
  }

  // --- private ---

  toggleAddMode(show) {
    const btn = this.element.querySelector("[data-add-btn]");
    if (btn) btn.classList.toggle("hidden", show);
    if (this.hasAddWrapTarget) this.addWrapTarget.classList.toggle("hidden", !show);
  }

  updateState() {
    const items = this.listTarget.querySelectorAll("[data-plan-id]");
    const count = items.length;
    this.countTarget.textContent = count;

    if (count === 0) {
      this.emptyTarget.classList.remove("hidden");
      this.listTarget.classList.add("hidden");
    } else {
      this.emptyTarget.classList.add("hidden");
      this.listTarget.classList.remove("hidden");
    }
  }

  buildPlanItem(id, name) {
    return `
      <div data-plan-id="${id}" data-plan-name="${this.escapeHtml(name)}"
           class="w-full block text-left rounded-[6px] mb-[5px] outline-hidden transition-all duration-200 ease-linear active:scale-[0.995] text-black bg-[#f8f8f8] hover:bg-[#f2f2f2] py-[5px] px-[10px]">
        <input type="hidden" name="plan_ids[]" value="${id}">
        <div class="flex w-full items-center">
          <div class="flex items-center flex-1 min-w-0">
            <div class="self-center text-[21px] text-center pr-[10px] [&>svg]:w-[21px]">
              <i class="fa-regular fa-tag"></i>
            </div>
            <div class="flex-1 grid gap-[2px] min-w-0">
              <span class="block font-normal leading-[1.3] text-[14px] opacity-80">${this.escapeHtml(name)}</span>
            </div>
          </div>
          <div class="pl-[15px] shrink-0">
            <button type="button" data-action="manage--advanced-plans#remove"
                    class="inline-flex items-center justify-center h-[32px] px-[12px] text-[14px] rounded-[8px] bg-white text-[#000000] font-medium cursor-pointer">
              <i class="fa-regular fa-trash-can"></i>
            </button>
          </div>
        </div>
      </div>`;
  }

  escapeHtml(text) {
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
  }
}
